import classnames from 'classnames';
import { Heading } from '@stadionhq-v3/base-ui';
import { MatchStatsRow } from '@stadionhq-v3/football-ui';
import styles from './combinedFormGuide.module.scss';
import {
  CombinedFormGuideProps,
  MATCH_RESULT,
  Result,
} from './combinedFormGuide.types';

const CombinedFormGuide = ({
  homeTeamCrest,
  awayTeamCrest,
  homeTeamName,
  awayTeamName,
  drawAbbreviated,
  formLabel,
  lossAbbreviated,
  playedHeading,
  homeTeamLeaguePlayed,
  awayTeamLeaguePlayed,
  pointsHeading,
  homeTeamLeaguePoints,
  awayTeamLeaguePoints,
  positionHeading,
  homeTeamLeaguePosition,
  awayTeamLeaguePosition,
  winAbbreviated,
  homeTeamResults = [],
  awayTeamResults = [],
  showLeagueStats,
  nativeProps,
  primaryTeam,
  classNames,
}: CombinedFormGuideProps) => {
  const classes = classnames([styles.tokens, styles.formGuide], classNames);

  const getAbbreviatedResult = (result: Result) => {
    switch (result) {
      case MATCH_RESULT.WIN:
        return winAbbreviated;
      case MATCH_RESULT.DRAW:
        return drawAbbreviated;
      case MATCH_RESULT.LOSS:
        return lossAbbreviated;
      default:
        return '-';
    }
  };

  return (
    <div
      {...nativeProps}
      className={classes}
      data-component="CombinedFormGuide"
    >
      <div className={classnames(styles.teamsAndCrestsContainer)}>
        <div className={classnames(styles.homeTeamAndCrest)}>
          <div className={classnames(styles.teamCrest)}>{homeTeamCrest}</div>

          <Heading as="h6" classNames={[classnames(styles.teamName)]}>
            {homeTeamName}
          </Heading>
        </div>
        <div className={classnames(styles.awayTeamAndCrest)}>
          <div className={classnames(styles.teamCrest)}>{awayTeamCrest}</div>

          <Heading as="h6" classNames={[classnames(styles.awayTeamName)]}>
            {awayTeamName}
          </Heading>
        </div>
      </div>

      <div className={classnames(styles.statsContainer)}>
        <div className={classnames(styles.formContainer)}>
          <div className={classnames(styles.formItems)}>
            {homeTeamResults.map(({ id, result }) => (
              <div
                key={`game-${id}-${result}`}
                className={classnames(styles.formGame)}
              >
                <span className={classnames(styles[result.toLowerCase()])}>
                  {getAbbreviatedResult(result)}
                </span>
              </div>
            ))}
          </div>

          <p className={classnames(styles.formLabel)}>{formLabel}</p>

          <div className={classnames(styles.formItems)}>
            {awayTeamResults.map(({ id, result }) => (
              <div
                key={`game-${id}-${result}`}
                className={classnames(styles.formGame)}
              >
                <span className={classnames(styles[result.toLowerCase()])}>
                  {getAbbreviatedResult(result)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {showLeagueStats && (
          <div className={classnames(styles.teamsStats)}>
            <MatchStatsRow
              homeValue={Number(homeTeamLeaguePosition)}
              awayValue={Number(awayTeamLeaguePosition)}
              title={positionHeading}
              primaryTeam={primaryTeam}
              classNames={[classnames(styles.teamsStatsRow)]}
            />

            <MatchStatsRow
              homeValue={Number(homeTeamLeaguePlayed)}
              awayValue={Number(awayTeamLeaguePlayed)}
              title={playedHeading}
              primaryTeam={primaryTeam}
              classNames={[classnames(styles.teamsStatsRow)]}
            />

            <MatchStatsRow
              homeValue={Number(homeTeamLeaguePoints)}
              awayValue={Number(awayTeamLeaguePoints)}
              title={pointsHeading}
              primaryTeam={primaryTeam}
              classNames={[classnames(styles.teamsStatsRow)]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CombinedFormGuide;
